export const KITCHENS_GET_REQUEST = "KITCHENS_GET_REQUESTED";
export const KITCHENS_GET_SUCCESS = "KITCHENS_GET_SUCCESS";
export const KITCHENS_GET_ERROR = "KITCHENS_GET_ERROR";
